import React, { useMemo, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

const outputKeyToLabelMapping = { chooseColumns: "選擇匯出資料", };

/*---- Main Modal Component ----*/
const OutputExcelModal = ({ isOutputModalOpen, setIsOutputModalOpen, downloadExcel }) => {  

  const [modalTitle, setModalTitle] = useState("匯出 Excel 檔");
  const orderedOutputKeys = ["chooseColumns"];

  const [columnCheckboxes, setColumnCheckboxes] = useState([
    { id: 'numberColumn', label: '編號', checked: false },
    { id: 'originalText', label: '原始段落', checked: false },
    { id: 'translatedText', label: '翻譯結果', checked: false },
    { id: 'statusCode', label: '狀態', checked: false },
    { id: 'highestSim', label: '最高相似度', checked: false },
  ]);

  const handleColumnCheckboxChange = (index) => {
    const updatedCheckboxes = [...columnCheckboxes];
    updatedCheckboxes[index].checked = !updatedCheckboxes[index].checked;
    setColumnCheckboxes(updatedCheckboxes);
  };

  const checkedColumns = useMemo(() => {
    return columnCheckboxes.filter((c)=>c.checked===true).map((m)=>m.id);
  }, [columnCheckboxes]);

  return (
    
    <React.Fragment>
    {/*--- Modal for output Excel file ---*/}

      <Modal isOpen={isOutputModalOpen} toggle={() => setIsOutputModalOpen(!isOutputModalOpen)}>
        <ModalHeader toggle={() => setIsOutputModalOpen(!isOutputModalOpen)}>{modalTitle}</ModalHeader>

        {/* Modal Body */}
        <ModalBody>
          {orderedOutputKeys.map((key) => (

            <div key={key} style={{ marginBottom: "15px" }}>

              <p>{outputKeyToLabelMapping[key] || key}:</p>

              {key === "chooseColumns" ? (
                
                columnCheckboxes.map((checkbox, index) => (
                  <div key={checkbox.id}>
                    <input
                      type="checkbox"
                      id={checkbox.id}
                      checked={checkbox.checked}
                      onChange={()=>{}}
                      onClick={() => handleColumnCheckboxChange(index)}
                    />
                    <label style={{ marginLeft: "0.5rem" }} htmlFor={checkbox.id}>{checkbox.label}</label>
                  </div>
                ))
                
              ) : (
                <textarea
                  value={modalData[key]}
                  onChange={(e) => {
                    setModalData((prevData) => ({
                      ...prevData,
                      [key]: e.target.value
                    }));
                    adjustTextAreaHeight(e.target);
                  }}
                  style={{ width: "100%", resize: 'none', overflow: 'hidden' }}
                  className="form-control"
                  readOnly={key === "originalText"}
                />
              )}
              
            </div>
          ))}
        </ModalBody>

        {/* Modal Footer */}
        <ModalFooter>
          <Button 
            color="primary" 
            onClick={() => {
              downloadExcel(checkedColumns);
              setIsOutputModalOpen(false);
            }}
          >
            開始匯出
          </Button>
          <Button color="secondary" onClick={() => setIsOutputModalOpen(false)}>取消匯出</Button>
        </ModalFooter>

      </Modal>

      {/*--- Modal for output Excel file Tail ---*/}
    </React.Fragment>
  );

};

export default OutputExcelModal;


